/*
 * Copyright (c) 2026. Tooling Team
 */

import { useGetLabDomainBuildsListQuery } from "../app/services/labDomainApi";

export default () => {
  const { data: buildsData } = useGetLabDomainBuildsListQuery();

  return {
    state: {
      labDomainBuildRowData: Array.isArray(buildsData) ? buildsData : [],
    },
  };
};
